export default "__VITE_ASSET__BTICVkv2__"